import { render, staticRenderFns } from "./contenido.vue?vue&type=template&id=1c09dcbe&scoped=true&"
import script from "./contenido.vue?vue&type=script&lang=js&"
export * from "./contenido.vue?vue&type=script&lang=js&"
import style0 from "./contenido.vue?vue&type=style&index=0&id=1c09dcbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c09dcbe",
  null
  
)

export default component.exports